/*

copy paste below into window f12 devtools to regenrate this map

function createSeoParameterToTextHashMap() {
    const map = {}
    const groupElements = Array.from(document.querySelectorAll('[data-seo-group]'))
    groupElements.forEach(el => {
        const groupName = el.getAttribute('data-seo-group')
         const value = el.getAttribute('data-seo')
        const valueContent =  {
                         text: el.nextElementSibling?.getAttribute('title'),
                         merkmal: el.getAttribute('data-opening-type') || el.getAttribute('data-merkmal'),
                         merkmalDescription: el.getAttribute('data-merkmal-description'),
                        displayGroup: merkmaleGroupsMapping[el.getAttribute('data-group') + '_' +  el.getAttribute('data-merkmal')] || el.closest('.form-container')?.firstElementChild.textContent.replace(':', ''),
                     }

        if(map[groupName]){
            map[groupName].values[value] = valueContent
        } else {

            map[groupName] = {
                name: el.getAttribute('data-seo-group'),
                text: el.getAttribute('data-group'),
                base: el.getAttribute('data-id-base'),
                values: {
                     [value]: valueContent
                }
            }
        }


    })
    return map
}
createSeoParameterToTextHashMap()

 */

import { filterConfig } from "@modules/global/filter-config.ts"

export function getDisplayGroup(group: string, value: string) {
    if (filterConfig.groups.select.includes(group)) {
        return FILTER_GROUP_NAME_MAP[group]?.values.ANY?.displayGroup
    }
    return FILTER_GROUP_NAME_MAP[group]?.values[value]?.displayGroup
}

export const FILTER_GROUP_NAME_MAP: Record<
    string,
    {
        name: string
        text: string
        base: string | null
        values: Record<
            string,
            { text?: string; merkmal: string | null; merkmalDescription: string | null; displayGroup: string }
        >
    }
> = {
    rubrik: {
        name: "rubrik",
        text: "Rubrik",
        base: "rubrik",
        values: {
            "huren-hostessen": {
                text: "Ladies",
                merkmal: null,
                merkmalDescription: "Ladies",
                displayGroup: "Rubriken",
            },
            "bordelle-laufhaeuser": {
                text: "Locations",
                merkmal: null,
                merkmalDescription: "Locations",
                displayGroup: "Rubriken",
            },
            escort: {
                text: "Escort",
                merkmal: null,
                merkmalDescription: "Escort",
                displayGroup: "Rubriken",
            },
            "transen-shemale": {
                text: "TS/TV",
                merkmal: null,
                merkmalDescription: "TS/TV",
                displayGroup: "Rubriken",
            },
            "erotische-massage": {
                text: "Massage",
                merkmal: null,
                merkmalDescription: "Massage",
                displayGroup: "Rubriken",
            },
            "domina-sm": {
                text: "Bizarr-SM",
                merkmal: null,
                merkmalDescription: "Bizarr-SM",
                displayGroup: "Rubriken",
            },
            "fkk-saunaclubs": {
                text: "FKK-Clubs",
                merkmal: null,
                merkmalDescription: "FKK-Clubs",
                displayGroup: "Rubriken",
            },
            "fkk-girls": {
                text: "FKK-Girls",
                merkmal: null,
                merkmalDescription: "FKK-Girls",
                displayGroup: "Rubriken",
            },
            swinger: {
                text: "Swinger",
                merkmal: null,
                merkmalDescription: "Swinger",
                displayGroup: "Rubriken",
            },
            webcams: {
                text: "Webcams",
                merkmal: null,
                merkmalDescription: "Webcams",
                displayGroup: "Rubriken",
            },
            telefonsex: {
                text: "Telefonsex",
                merkmal: null,
                merkmalDescription: "Telefonsex",
                displayGroup: "Rubriken",
            },
            onlineservice: {
                text: "Onlineservice",
                merkmal: null,
                merkmalDescription: "Onlineservice",
                displayGroup: "Rubriken",
            },
            sexchat: {
                text: "Sexchat",
                merkmal: null,
                merkmalDescription: "Sexchat",
                displayGroup: "Rubriken",
            },
        },
    },
    exklusiv: {
        name: "exklusiv",
        text: "Bridge_MitStarsContent",
        base: "filterId",
        values: {
            "mit-stars-content": {
                text: "LadiesSTARS",
                merkmal: "mitstarscontent",
                merkmalDescription: "LadiesSTARS",
                displayGroup: "Exklusive Inhalte",
            },
            "mit-premium-beitraegen": {
                text: "Premium-Beiträge",
                merkmal: "mitpremiumposts",
                merkmalDescription: "Premium-Beiträge",
                displayGroup: "Exklusive Inhalte",
            },
        },
    },
    alter: {
        name: "alter",
        text: "Alter",
        base: null,
        values: {
            ANY: {
                merkmal: null,
                merkmalDescription: null,
                displayGroup: "Alter",
            },
        },
    },
    groesse: {
        name: "groesse",
        text: "Koerpergroesse",
        base: null,
        values: {
            ANY: {
                merkmal: null,
                merkmalDescription: null,
                displayGroup: "Körpergröße",
            },
        },
    },
    figur: {
        name: "figur",
        text: "Figur",
        base: "merkmal",
        values: {
            skinny: {
                text: "sehr schlank",
                merkmal: "sehr_schlank",
                merkmalDescription: "sehr schlank",
                displayGroup: "Figur",
            },
            schlank: {
                text: "schlank",
                merkmal: "schlank",
                merkmalDescription: "schlank",
                displayGroup: "Figur",
            },
            normal: {
                text: "mittel",
                merkmal: "mittel",
                merkmalDescription: "mittel",
                displayGroup: "Figur",
            },
            mollig: {
                text: "mollig",
                merkmal: "mollig",
                merkmalDescription: "mollig",
                displayGroup: "Figur",
            },
            dick: {
                text: "sehr mollig",
                merkmal: "sehr_mollig",
                merkmalDescription: "sehr mollig",
                displayGroup: "Figur",
            },
        },
    },
    typ: {
        name: "typ",
        text: "Typ",
        base: "merkmal",
        values: {
            afrikanisch: {
                text: "afrikanisch",
                merkmal: "afrikanisch",
                merkmalDescription: "afrikanisch",
                displayGroup: "Typ",
            },
            asia: {
                text: "asiatisch",
                merkmal: "asiatisch",
                merkmalDescription: "asiatisch",
                displayGroup: "Typ",
            },
            deutsch: {
                text: "deutsch",
                merkmal: "deutsch",
                merkmalDescription: "deutsch",
                displayGroup: "Typ",
            },
            exotisch: {
                text: "exotisch",
                merkmal: "exotisch",
                merkmalDescription: "exotisch",
                displayGroup: "Typ",
            },
            latina: {
                text: "latina",
                merkmal: "latina",
                merkmalDescription: "latina",
                displayGroup: "Typ",
            },
            arabisch: {
                text: "orientalisch",
                merkmal: "orientalisch",
                merkmalDescription: "orientalisch",
                displayGroup: "Typ",
            },
            osteuropaeisch: {
                text: "osteuropäisch",
                merkmal: "osteuropaeisch",
                merkmalDescription: "osteuropäisch",
                displayGroup: "Typ",
            },
            skandinavisch: {
                text: "skandinavisch",
                merkmal: "skandinavisch",
                merkmalDescription: "skandinavisch",
                displayGroup: "Typ",
            },
            europaeisch: {
                text: "westeuropäisch",
                merkmal: "westeuropaeisch",
                merkmalDescription: "westeuropäisch",
                displayGroup: "Typ",
            },
        },
    },
    busen: {
        name: "busen",
        text: "Oberweite",
        base: "merkmal",
        values: {
            klein: {
                text: "klein",
                merkmal: "klein",
                merkmalDescription: "klein",
                displayGroup: "Busen",
            },
            mittel: {
                text: "mittel",
                merkmal: "mittel",
                merkmalDescription: "mittel",
                displayGroup: "Busen",
            },
            gross: {
                text: "groß",
                merkmal: "gross",
                merkmalDescription: "groß",
                displayGroup: "Busen",
            },
            dick: {
                text: "riesig",
                merkmal: "riesig",
                merkmalDescription: "riesig",
                displayGroup: "Busen",
            },
            naturbusen: {
                text: "Naturbusen",
                merkmal: "naturbusen",
                merkmalDescription: "Naturbusen",
                displayGroup: "Busen",
            },
        },
    },
    intimbereich: {
        name: "intimbereich",
        text: "Intimbereich",
        base: "merkmal",
        values: {
            rasiert: {
                text: "total rasiert",
                merkmal: "total_rasiert",
                merkmalDescription: "total rasiert",
                displayGroup: "Intimbereich",
            },
            teilrasiert: {
                text: "teilrasiert",
                merkmal: "teilrasiert",
                merkmalDescription: "teilrasiert",
                displayGroup: "Intimbereich",
            },
            behaart: {
                text: "behaart",
                merkmal: "behaart",
                merkmalDescription: "behaart",
                displayGroup: "Intimbereich",
            },
            "stark-behaart": {
                text: "stark behaart",
                merkmal: "stark_behaart",
                merkmalDescription: "stark behaart",
                displayGroup: "Intimbereich",
            },
        },
    },
    hautton: {
        name: "hautton",
        text: "Hautton",
        base: "merkmal",
        values: {
            hell: {
                text: "helle Haut",
                merkmal: "helle_haut",
                merkmalDescription: "helle Haut",
                displayGroup: "Hautton",
            },
            neutral: {
                text: "mittlere Haut",
                merkmal: "normale_haut",
                merkmalDescription: "mittlere Haut",
                displayGroup: "Hautton",
            },
            braun: {
                text: "bräunliche Haut",
                merkmal: "braeunliche_haut",
                merkmalDescription: "bräunliche Haut",
                displayGroup: "Hautton",
            },
            schwarz: {
                text: "schwarze Haut",
                merkmal: "schwarze_haut",
                merkmalDescription: "schwarze Haut",
                displayGroup: "Hautton",
            },
        },
    },
    haarfarbe: {
        name: "haarfarbe",
        text: "Haarfarbe",
        base: "merkmal",
        values: {
            blond: {
                text: "blond",
                merkmal: "blond",
                merkmalDescription: "blond",
                displayGroup: "Haarfarbe",
            },
            dunkelblond: {
                text: "dunkelblond",
                merkmal: "dunkelblond",
                merkmalDescription: "dunkelblond",
                displayGroup: "Haarfarbe",
            },
            bruenett: {
                text: "brünett",
                merkmal: "bruenett",
                merkmalDescription: "brünett",
                displayGroup: "Haarfarbe",
            },
            rotbraun: {
                text: "rotbraun",
                merkmal: "rotbraun",
                merkmalDescription: "rotbraun",
                displayGroup: "Haarfarbe",
            },
            dunkelbraun: {
                text: "dunkelbraun",
                merkmal: "dunkelbraun",
                merkmalDescription: "dunkelbraun",
                displayGroup: "Haarfarbe",
            },
            schwarz: {
                text: "schwarz",
                merkmal: "schwarz",
                merkmalDescription: "schwarz",
                displayGroup: "Haarfarbe",
            },
            rot: {
                text: "rot",
                merkmal: "rot",
                merkmalDescription: "rot",
                displayGroup: "Haarfarbe",
            },
            grau: {
                text: "grau",
                merkmal: "grau",
                merkmalDescription: "grau",
                displayGroup: "Haarfarbe",
            },
        },
    },
    koerperschmuck: {
        name: "koerperschmuck",
        text: "Koerperschmuck",
        base: "merkmal",
        values: {
            intimpiercing: {
                text: "Intim-Piercing",
                merkmal: "intim_piercing",
                merkmalDescription: "Intim-Piercing",
                displayGroup: "Körperschmuck",
            },
            brustwarzenpiercing: {
                text: "Brust-Piercing",
                merkmal: "brust_piercing",
                merkmalDescription: "Brust-Piercing",
                displayGroup: "Körperschmuck",
            },
            piercing: {
                text: "Gesichts-/Nabelp.",
                merkmal: "gesicht_nabel_piercing",
                merkmalDescription: "Gesichts-/Nabelp.",
                displayGroup: "Körperschmuck",
            },
            zungenpiercing: {
                text: "Zungen-Piercing",
                merkmal: "zungen_piercing",
                merkmalDescription: "Zungen-Piercing",
                displayGroup: "Körperschmuck",
            },
            "sexy-tattoos": {
                text: "Tattoos",
                merkmal: "tattoos",
                merkmalDescription: "Tattoos",
                displayGroup: "Körperschmuck",
            },
            ohne: {
                text: "kein Körperschmuck",
                merkmal: "kein_koerperschmuck",
                merkmalDescription: "kein Körperschmuck",
                displayGroup: "Körperschmuck",
            },
        },
    },
    sonstiges: {
        name: "sonstiges",
        text: "Nichtraucher",
        base: "merkmal",
        values: {
            nichtraucher: {
                text: "Nichtraucher",
                merkmal: "nichtraucher",
                merkmalDescription: "Nichtraucher",
                displayGroup: "Sonstiges",
            },
            "gesicht-erkennbar": {
                text: "Gesicht erkennbar",
                merkmal: "gesicht_erkennbar",
                merkmalDescription: "Gesicht erkennbar",
                displayGroup: "Sonstiges",
            },
            videos: {
                text: "mit Video",
                merkmal: "with_video",
                merkmalDescription: "mit Video",
                displayGroup: "Sonstiges",
            },
            empfehlung: {
                text: "Empfehlung",
                merkmal: "with_empfehlung",
                merkmalDescription: "Empfehlung",
                displayGroup: "Sonstiges",
            },
            geimpft: {
                text: "geimpft",
                merkmal: "geimpft",
                merkmalDescription: "geimpft",
                displayGroup: "Sonstiges",
            },
            ab18: {
                text: "Mit 18+ Inhalten",
                merkmal: "ab18",
                merkmalDescription: "Mit 18+ Inhalten",
                displayGroup: "Sonstiges",
            },
        },
    },
    haarlaenge: {
        name: "haarlaenge",
        text: "Haarlaenge",
        base: "merkmal",
        values: {
            glatze: {
                text: "Glatze",
                merkmal: "glatze",
                merkmalDescription: "Glatze",
                displayGroup: "Haarlänge",
            },
            kurz: {
                text: "kurz",
                merkmal: "kurz",
                merkmalDescription: "kurz",
                displayGroup: "Haarlänge",
            },
            kinnlang: {
                text: "kinnlang",
                merkmal: "kinnlang",
                merkmalDescription: "kinnlang",
                displayGroup: "Haarlänge",
            },
            schulterlang: {
                text: "schulterlang",
                merkmal: "schulterlang",
                merkmalDescription: "schulterlang",
                displayGroup: "Haarlänge",
            },
            rueckenlang: {
                text: "rückenlang",
                merkmal: "rueckenlang",
                merkmalDescription: "rückenlang",
                displayGroup: "Haarlänge",
            },
        },
    },
    geschlecht: {
        name: "geschlecht",
        text: "Geschlecht",
        base: "merkmal",
        values: {
            weiblich: {
                text: "weiblich",
                merkmal: "weiblich",
                merkmalDescription: "weiblich",
                displayGroup: "Geschlecht",
            },
            maennlich: {
                text: "männlich",
                merkmal: "maennlich",
                merkmalDescription: "männlich",
                displayGroup: "Geschlecht",
            },
            trans: {
                text: "trans",
                merkmal: "trans",
                merkmalDescription: "trans",
                displayGroup: "Geschlecht",
            },
            "paar-duo": {
                text: "Paar/Duo",
                merkmal: "paar_duo",
                merkmalDescription: "Paar/Duo",
                displayGroup: "Geschlecht",
            },
        },
    },
    augenfarbe: {
        name: "augenfarbe",
        text: "Augenfarbe",
        base: "merkmal",
        values: {
            braun: {
                text: "braun",
                merkmal: "braun",
                merkmalDescription: "braun",
                displayGroup: "Augenfarbe",
            },
            blau: {
                text: "blau",
                merkmal: "blau",
                merkmalDescription: "blau",
                displayGroup: "Augenfarbe",
            },
            gruen: {
                text: "grün",
                merkmal: "gruen",
                merkmalDescription: "grün",
                displayGroup: "Augenfarbe",
            },
            "blau-gruen-grau": {
                text: "blau-grün, grau",
                merkmal: "blau_gruen_grau",
                merkmalDescription: "blau-grün, grau",
                displayGroup: "Augenfarbe",
            },
        },
    },
    service: {
        name: "service",
        text: "Service",
        base: "merkmal",
        values: {
            anal: {
                text: "AV",
                merkmal: "av",
                merkmalDescription: "AV",
                displayGroup: "Beliebt",
            },
            zungenkuss: {
                text: "ZK",
                merkmal: "zk",
                merkmalDescription: "ZK",
                displayGroup: "Beliebt",
            },
            "gv-sex": {
                text: "GV",
                merkmal: "gv",
                merkmalDescription: "GV",
                displayGroup: "Beliebt",
            },
            girlfriendsex: {
                text: "GF6",
                merkmal: "gf6",
                merkmalDescription: "GF6",
                displayGroup: "Beliebt",
            },
            franzoesisch: {
                text: "Franz.",
                merkmal: "franz",
                merkmalDescription: "Franz.",
                displayGroup: "Beliebt",
            },
            "massage-only": {
                text: "nur Massage",
                merkmal: "nur_massage_kein_gv",
                merkmalDescription: "nur Massage",
                displayGroup: "Beliebt",
            },
            deepthroat: {
                text: "D**p Thr**t",
                merkmal: "dt",
                merkmalDescription: "D**p Thr**t",
                displayGroup: "Franz",
            },
            lecken: {
                text: "Franz. bei ihr",
                merkmal: "franz_bei_ihr",
                merkmalDescription: "Franz. bei ihr",
                displayGroup: "Franz",
            },
            "69-stellung": {
                text: "69",
                merkmal: "69",
                merkmalDescription: "69",
                displayGroup: "Franz",
            },
            "av-passiv": {
                text: "AV bei ihm",
                merkmal: "av_bei_ihm",
                merkmalDescription: "AV bei ihm",
                displayGroup: "Anal",
            },
            "fa-aktiv": {
                text: "FA aktiv",
                merkmal: "fa_anal_massagen_aktiv",
                merkmalDescription: "FA aktiv",
                displayGroup: "Anal",
            },
            "fa-passiv": {
                text: "FA passiv",
                merkmal: "fa_anal_massagen_passiv",
                merkmalDescription: "FA passiv",
                displayGroup: "Anal",
            },
            "za-aktiv": {
                text: "ZA aktiv",
                merkmal: "za_aktiv",
                merkmalDescription: "ZA aktiv",
                displayGroup: "Anal",
            },
            "za-passiv": {
                text: "ZA passiv",
                merkmal: "za_passiv",
                merkmalDescription: "ZA passiv",
                displayGroup: "Anal",
            },
            "natursekt-aktiv": {
                text: "NS aktiv",
                merkmal: "ns_aktiv",
                merkmalDescription: "NS aktiv",
                displayGroup: "Bizarr Basic",
            },
            "natursekt-passiv": {
                text: "NS passiv",
                merkmal: "ns_passiv",
                merkmalDescription: "NS passiv",
                displayGroup: "Bizarr Basic",
            },
            "kaviar-aktiv": {
                text: "KV aktiv",
                merkmal: "kv_aktiv",
                merkmalDescription: "KV aktiv",
                displayGroup: "Bizarr Basic",
            },
            "kaviar-passiv": {
                text: "KV passiv",
                merkmal: "kv_passiv",
                merkmalDescription: "KV passiv",
                displayGroup: "Bizarr Basic",
            },
            dominant: {
                text: "dominant",
                merkmal: "domina",
                merkmalDescription: "dominant",
                displayGroup: "Bizarr Basic",
            },
            devot: {
                text: "devot",
                merkmal: "devot",
                merkmalDescription: "devot",
                displayGroup: "Bizarr Basic",
            },
            damen: {
                text: "Damen",
                merkmal: "service_fuer_damen",
                merkmalDescription: "Damen",
                displayGroup: "Service für",
            },
            paare: {
                text: "Paare",
                merkmal: "service_fuer_paare",
                merkmalDescription: "Paare",
                displayGroup: "Service für",
            },
            behinderte: {
                text: "Menschen mit Behinderung",
                merkmal: "behindertenbesuche",
                merkmalDescription: "Menschen mit Behinderung",
                displayGroup: "Service für",
            },
            "flotter-dreier-mff": {
                text: "Flotter Dreier (MFF)",
                merkmal: "mff",
                merkmalDescription: "Flotter Dreier (MFF)",
                displayGroup: "Mehrere Personen",
            },
            "flotter-dreier-mmf": {
                text: "Zu dritt (MMF)",
                merkmal: "mmf",
                merkmalDescription: "Zu dritt (MMF)",
                displayGroup: "Mehrere Personen",
            },
            herrenrunde: {
                text: "Herrenrunde",
                merkmal: "herrenrunde",
                merkmalDescription: "Herrenrunde",
                displayGroup: "Mehrere Personen",
            },
            gruppensex: {
                text: "GS (Gruppen-S*x)",
                merkmal: "gs",
                merkmalDescription: "GS (Gruppen-S*x)",
                displayGroup: "Mehrere Personen",
            },
            sandwich: {
                text: "SW (S*ndw*ch)",
                merkmal: "sw",
                merkmalDescription: "SW (S*ndw*ch)",
                displayGroup: "Mehrere Personen",
            },
            "body-to-body-massage": {
                text: "Body-to-Body M.",
                merkmal: "body_to_body_massage",
                merkmalDescription: "Body-to-Body M.",
                displayGroup: "Massage",
            },
            "erotische-massage": {
                text: "erotische Massage",
                merkmal: "erotische_massagen",
                merkmalDescription: "erotische Massage",
                displayGroup: "Massage",
            },
            ganzkoerpermassage: {
                text: "Ganzkörperm.",
                merkmal: "ganzkoerpermassage",
                merkmalDescription: "Ganzkörperm.",
                displayGroup: "Massage",
            },
            handentspannung: {
                text: "HE (Handentsp.)",
                merkmal: "he",
                merkmalDescription: "HE (Handentsp.)",
                displayGroup: "Massage",
            },
            "intim-massage": {
                text: "Intim-Massage",
                merkmal: "intim_massagen",
                merkmalDescription: "Intim-Massage",
                displayGroup: "Massage",
            },
            "oel-massage": {
                text: "Öl-Massage",
                merkmal: "oel_massage",
                merkmalDescription: "Öl-Massage",
                displayGroup: "Massage",
            },
            paarmassage: {
                text: "Pärchen-Massage",
                merkmal: "paerchen_massage",
                merkmalDescription: "Pärchen-Massage",
                displayGroup: "Massage",
            },
            "po-massage": {
                text: "Po-Massage",
                merkmal: "po_massage",
                merkmalDescription: "Po-Massage",
                displayGroup: "Massage",
            },
            "prostata-massage": {
                text: "Pr*stata-Massage",
                merkmal: "prostata_massage",
                merkmalDescription: "Pr*stata-Massage",
                displayGroup: "Massage",
            },
            "duo-massage": {
                text: "Synchron-/Duo-M.",
                merkmal: "synchron_duo_massage",
                merkmalDescription: "Synchron-/Duo-M.",
                displayGroup: "Massage",
            },
            "tantra-massage": {
                text: "Tantra-Massage",
                merkmal: "tantra_massage",
                merkmalDescription: "Tantra-Massage",
                displayGroup: "Massage",
            },
            "thai-massage": {
                text: "Thai-Massage",
                merkmal: "thai_massage",
                merkmalDescription: "Thai-Massage",
                displayGroup: "Massage",
            },
            bondage: {
                text: "Bondage/Fess**ung",
                merkmal: "bondage",
                merkmalDescription: "Bondage/Fess**ung",
                displayGroup: "Bizarr weitere",
            },
            "brustwarzenspiele-aktiv": {
                text: "Bru*tw.-Spiele a.",
                merkmal: "bs_aktiv",
                merkmalDescription: "Bru*tw.-Spiele a.",
                displayGroup: "Bizarr weitere",
            },
            "brustwarzenspiele-passiv": {
                text: "Bru*tw.-Spiele p.",
                merkmal: "bs_passiv",
                merkmalDescription: "Bru*tw.-Spiele p.",
                displayGroup: "Bizarr weitere",
            },
            erziehung: {
                text: "Erz.",
                merkmal: "erziehung",
                merkmalDescription: "Erz.",
                displayGroup: "Bizarr weitere",
            },
            "fesselspiele-aktiv": {
                text: "Fesselspiele aktiv",
                merkmal: "fs_aktiv",
                merkmalDescription: "Fesselspiele aktiv",
                displayGroup: "Bizarr weitere",
            },
            "fesselspiele-passiv": {
                text: "Fesselspiele passiv",
                merkmal: "fs_passiv",
                merkmalDescription: "Fesselspiele passiv",
                displayGroup: "Bizarr weitere",
            },
            "fetisch-spiele": {
                text: "Fetisch-Spielchen",
                merkmal: "fetisch_spielchen",
                merkmalDescription: "Fetisch-Spielchen",
                displayGroup: "Bizarr weitere",
            },
            "faustfick-aktiv": {
                text: "FF aktiv",
                merkmal: "ff_aktiv",
                merkmalDescription: "FF aktiv",
                displayGroup: "Bizarr weitere",
            },
            "faustfick-passiv": {
                text: "FF passiv",
                merkmal: "ff_passiv",
                merkmalDescription: "FF passiv",
                displayGroup: "Bizarr weitere",
            },
            facesitting: {
                text: "FS (Facesitting)",
                merkmal: "fs",
                merkmalDescription: "FS (Facesitting)",
                displayGroup: "Bizarr weitere",
            },
            "lack-leder-fetisch": {
                text: "Lack, Leder u. Latex",
                merkmal: "lack_leder",
                merkmalDescription: "Lack, Leder u. Latex",
                displayGroup: "Bizarr weitere",
            },
            "leichte-erziehung": {
                text: "leichte Erz.",
                merkmal: "leichte_erziehung",
                merkmalDescription: "leichte Erz.",
                displayGroup: "Bizarr weitere",
            },
            "sanfte-schlaege": {
                text: "sanfte Schl.",
                merkmal: "sanfte_schlaege",
                merkmalDescription: "sanfte Schl.",
                displayGroup: "Bizarr weitere",
            },
            "dirty-talk": {
                text: "Verbalerotik",
                merkmal: "verbalerotik",
                merkmalDescription: "Verbalerotik",
                displayGroup: "Bizarr weitere",
            },
            "ws-erotik": {
                text: "WS",
                merkmal: "ws",
                merkmalDescription: "WS",
                displayGroup: "Bizarr weitere",
            },
            "baden-duschen": {
                text: "Dusch-/Badeservice",
                merkmal: "bade_duschservice",
                merkmalDescription: "Dusch-/Badeservice",
                displayGroup: "Weitere",
            },
            "dildospiele-aktiv": {
                text: "DS aktiv",
                merkmal: "ds_aktiv",
                merkmalDescription: "DS aktiv",
                displayGroup: "Weitere",
            },
            "dildospiele-passiv": {
                text: "DS passiv",
                merkmal: "ds_passiv",
                merkmalDescription: "DS passiv",
                displayGroup: "Weitere",
            },
            "fotos-videos": {
                text: "Fotos/Videos möglich",
                merkmal: "fotos_videos_moeglich",
                merkmalDescription: "Fotos/Videos möglich",
                displayGroup: "Weitere",
            },
            "fusserotik-high-heels": {
                text: "Fuß-/Schuherotik",
                merkmal: "fuss_schuherotik",
                merkmalDescription: "Fuß-/Schuherotik",
                displayGroup: "Weitere",
            },
            "gesichtsbesamung-spritzen": {
                text: "GB passiv (Gesichtsb.)",
                merkmal: "gb_passiv",
                merkmalDescription: "GB passiv (Gesichtsb.)",
                displayGroup: "Weitere",
            },
            "hoden-lecken": {
                text: "EL",
                merkmal: "el",
                merkmalDescription: "EL",
                displayGroup: "Weitere",
            },
            intimrasur: {
                text: "Intimrasur",
                merkmal: "intimrasur",
                merkmalDescription: "Intimrasur",
                displayGroup: "Weitere",
            },
            strapserotik: {
                text: "Strapserotik",
                merkmal: "straps_erotik",
                merkmalDescription: "Strapserotik",
                displayGroup: "Weitere",
            },
            striptease: {
                text: "gekonnter Striptease",
                merkmal: "gekonnter_striptease",
                merkmalDescription: "gekonnter Striptease",
                displayGroup: "Weitere",
            },
            koerperbesamung: {
                text: "KB passiv (Körperb.)",
                merkmal: "kb_passiv",
                merkmalDescription: "KB passiv (Körperb.)",
                displayGroup: "Weitere",
            },
            lesbenshow: {
                text: "LS/Duo (Lesboshow)",
                merkmal: "ls_duo",
                merkmalDescription: "LS/Duo (Lesboshow)",
                displayGroup: "Weitere",
            },
            "masturbieren-wichsen": {
                text: "Mast.",
                merkmal: "masturbation",
                merkmalDescription: "Mast.",
                displayGroup: "Weitere",
            },
            "nylon-fetisch": {
                text: "Nylonerotik",
                merkmal: "nylonerotik",
                merkmalDescription: "Nylonerotik",
                displayGroup: "Weitere",
            },
            "outdoor-sex": {
                text: "Outdoor-Erotik",
                merkmal: "outdoor_erotik",
                merkmalDescription: "Outdoor-Erotik",
                displayGroup: "Weitere",
            },
            "erotische-rollenspiele": {
                text: "Rollenspiele",
                merkmal: "rollenspiele",
                merkmalDescription: "Rollenspiele",
                displayGroup: "Weitere",
            },
            "busensex-tittenfick": {
                text: "Spanisch / BV",
                merkmal: "spanisch",
                merkmalDescription: "Spanisch / BV",
                displayGroup: "Weitere",
            },
            squirting: {
                text: "Squ*rting",
                merkmal: "squirting",
                merkmalDescription: "Squ*rting",
                displayGroup: "Weitere",
            },
            begleitservice: {
                text: "Begleitservice",
                merkmal: "begleitservice",
                merkmalDescription: "Begleitservice",
                displayGroup: "Escort",
            },
            "frivol-ausgehen": {
                text: "Frivoles Ausgehen",
                merkmal: "frivoles_ausgehen",
                merkmalDescription: "Frivoles Ausgehen",
                displayGroup: "Escort",
            },
            urlaubsbegleitung: {
                text: "Urlaubsbegleitung",
                merkmal: "urlaubsbegleitung",
                merkmalDescription: "Urlaubsbegleitung",
                displayGroup: "Escort",
            },
            paarbesuche: {
                text: "Pärchenbesuche",
                merkmal: "paerchenbesuche",
                merkmalDescription: "Pärchenbesuche",
                displayGroup: "Escort",
            },
            swingerclub: {
                text: "Swingerclub-Begl.",
                merkmal: "swingerclubbegleitung",
                merkmalDescription: "Swingerclub-Begl.",
                displayGroup: "Escort",
            },
            "uebernachtung-gast": {
                text: "Übernacht. b. Gast",
                merkmal: "uebernachtung_beim_gast",
                merkmalDescription: "Übernacht. b. Gast",
                displayGroup: "Escort",
            },
            wochenendbegleitung: {
                text: "Wochenende",
                merkmal: "auch_am_we",
                merkmalDescription: "Wochenende",
                displayGroup: "Escort",
            },
            gastrobegleitung: {
                text: "Gastrobegleitung",
                merkmal: "gastronomie_begleitung",
                merkmalDescription: "Gastrobegleitung",
                displayGroup: "Escort",
            },
            messebegleitung: {
                text: "Messebegleitung",
                merkmal: "messe_begleitung",
                merkmalDescription: "Messebegleitung",
                displayGroup: "Escort",
            },
        },
    },
    treff: {
        name: "treff",
        text: "Auftrag_TreffenBesuchbar",
        base: "merkmal",
        values: {
            "treffen-besuchbar": {
                text: "besuchbar",
                merkmal: "treffen_besuchbar",
                merkmalDescription: "besuchbar",
                displayGroup: "Treffpunkte",
            },
            "treffen-haus": {
                text: "Hausbesuche",
                merkmal: "treffen_haus",
                merkmalDescription: "Hausbesuche",
                displayGroup: "Treffpunkte",
            },
            "treffen-hotel": {
                text: "Hotelbesuche",
                merkmal: "treffen_hotel",
                merkmalDescription: "Hotelbesuche",
                displayGroup: "Treffpunkte",
            },
            "treffen-buero": {
                text: "Bürobesuche",
                merkmal: "buerobesuche",
                merkmalDescription: "Bürobesuche",
                displayGroup: "Treffpunkte",
            },
            "treffen-parkplatz": {
                text: "Parkplatz-Treffen",
                merkmal: "treffen_parkplatz",
                merkmalDescription: "Parkplatz-Treffen",
                displayGroup: "Treffpunkte",
            },
        },
    },
    location: {
        name: "location",
        text: "ClusteredGirls",
        base: "merkmal",
        values: {
            "rollstuhlfahrer-geeignet": {
                text: "für Rollstuhlfahrer geeignet",
                merkmal: "rollstuhlfahrer_geeignet",
                merkmalDescription: "für Rollstuhlfahrer geeignet",
                displayGroup: "Location",
            },
        },
    },
    zeiten: {
        name: "zeiten",
        text: "Zeiten",
        base: "opening-type",
        values: {
            "jetzt-offen": {
                text: "jetzt geöffnet",
                merkmal: "now",
                merkmalDescription: "jetzt geöffnet",
                displayGroup: "Zeiten",
            },
            "vor-10": {
                text: "vor 10 Uhr",
                merkmal: "before10am",
                merkmalDescription: "vor 10 Uhr",
                displayGroup: "Zeiten",
            },
            "auch-samstag": {
                text: "auch Samstag",
                merkmal: "saturday",
                merkmalDescription: "auch Samstag",
                displayGroup: "Zeiten",
            },
            "heute-offen": {
                text: "heute geöffnet",
                merkmal: "today",
                merkmalDescription: "heute geöffnet",
                displayGroup: "Zeiten",
            },
            "nach-22": {
                text: "nach 22 Uhr",
                merkmal: "after10pm",
                merkmalDescription: "nach 22 Uhr",
                displayGroup: "Zeiten",
            },
            "auch-sonntag": {
                text: "auch Sonntag",
                merkmal: "sunday",
                merkmalDescription: "auch Sonntag",
                displayGroup: "Zeiten",
            },
        },
    },
}
